<template>
  <div class="dropdown-wrapper">
    <div class="select-container">
      <div class="select-container">
        <select 
          :id="dropdownId" 
          :value="modelValue" 
          @change="$emit('update:modelValue', $event.target.value)" 
          :class="{ 'dropdown-error': error }" 
          :disabled="disabled"
        >
          <option 
            value="" 
            disabled 
            :hidden="!!modelValue"
          >
            {{ placeholder }}
          </option>
          <option 
            v-for="option in options" 
            :key="option.value" 
            :value="option.value"
            :selected="option.value === modelValue"
          >
            {{ option.label }}
          </option>
        </select>

        <!-- Dropdown icon (Chevron) -->
        <svg class="dropdown-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
          <path d="M6 9L12 15L18 9" stroke="#5C656C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>

    <!-- Error message -->
    <div v-if="error" class="error-message">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666 7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.55992 4.28725H8.43992L8.38058 8.99392H7.61992L7.56125 4.28725H7.55992ZM7.99992 11.3819C7.92657 11.3828 7.85378 11.369 7.78584 11.3414C7.7179 11.3137 7.65617 11.2727 7.6043 11.2209C7.55243 11.169 7.51146 11.1073 7.4838 11.0393C7.45614 10.9714 7.44236 10.8986 7.44325 10.8253C7.44189 10.7518 7.45537 10.6788 7.48286 10.6106C7.51036 10.5425 7.55131 10.4806 7.60327 10.4286C7.65524 10.3766 7.71715 10.3357 7.7853 10.3082C7.85345 10.2807 7.92644 10.2672 7.99992 10.2686C8.31725 10.2686 8.55658 10.5086 8.55658 10.8253C8.55794 10.8987 8.54447 10.9717 8.51698 11.0399C8.48948 11.108 8.44853 11.1699 8.39656 11.2219C8.3446 11.2739 8.28269 11.3148 8.21454 11.3423C8.14639 11.3698 8.07339 11.3833 7.99992 11.3819Z" fill="#E50006" stroke="#E50006" stroke-width="0.2" />
      </svg>
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    placeholder: String,
    modelValue: [String, Number],
    options: {
      type: Array,
      required: true,
    },
    dropdownId: String,
    error: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
}
</script>

<style scoped>
.select-container {
  position: relative;
  width: 209px;
  height: 40px;
}

select {
  width: 100%;
  height: 100%;
  padding: 8px 36px 8px 14px; /* Left 14px | Right 36px to leave room for the icon */
  border-radius: 4px;
  border: 1px solid #667085;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  appearance: none;
  text-align: center;

  color: #5c656c;
  font-family: 'Archivo', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-transform: capitalize;

  /* To vertically center the text */
  display: flex;
  align-items: center;
}

/* Positioning the dropdown icon */
.dropdown-icon {
  position: absolute;
  top: 50%;
  right: 54px;
  transform: translateY(-50%);
  pointer-events: none;
}

/* Optional: Highlight on focus */
select:focus {
  outline: none;
  border-color: #667085;
  box-shadow: 0 0 0 1px #667085;
}

/* Error state */
.dropdown-error {
  border-color: #e50006 !important;
}

/* Disabled state */
select:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
  opacity: 0.6;
}

.dropdown-wrapper:has(select:disabled) .dropdown-icon {
  opacity: 0.6;
}
</style>
